import { api } from '../api';
import { exportInvSummaryExcel } from '../utils/export';
import { formatDate } from '../utils/format';
export const REPORT_DEFS = [
  {
    key: 'invoices',
    label: 'Invoices Report',
    fileName: 'invoices_report',
    endpoint: (p) => api.reports.invoices(p),
    filters: [
      { key: 'from', label: 'From', type: 'date' },
      { key: 'to', label: 'To', type: 'date' },
      { key: 'invoice_type', label: 'Type', type: 'select', options: ['sale', 'credit', 'tax_free'] },
      { key: 'status', label: 'Status', type: 'select', options: ['draft', 'approved', 'posted', 'void'] },
      { key: 'search', label: 'Search', type: 'text' },
    ],
    summaryKeys: [
      { key: 'count', label: 'Invoices', icon: 'bi bi-file-earmark-text' },
      { key: 'subtotal', label: 'Subtotal', money: true },
      { key: 'tax_amount', label: 'Tax', money: true },
      { key: 'wht_amount', label: 'WHT', money: true },
      { key: 'total', label: 'Total', money: true },
      { key: 'received', label: 'Received', money: true },
      { key: 'pending', label: 'Pending', money: true },
    ],
    columns: [
      { key: 'invoice_no', label: 'Invoice No' },
      { key: 'invoice_type', label: 'Type' },
      { key: 'date', label: 'Date' },
      { key: 'party', label: 'Party' },
      { key: 'status', label: 'Status' },
      { key: 'total', label: 'Total', render: (r) => Number(r.total || 0).toLocaleString() },
      { key: 'paid', label: 'Paid', render: (r) => Number(r.paid || 0).toLocaleString() },
      { key: 'remaining', label: 'Remaining', render: (r) => Number(r.remaining || 0).toLocaleString() },
      { key: 'created_by', label: 'Created By' },
    ],
  },
  {
    key: 'payments',
    label: 'Payments Report',
    fileName: 'payments_report',
    endpoint: (p) => api.reports.payments(p),
    filters: [
      { key: 'from', label: 'From', type: 'date' },
      { key: 'to', label: 'To', type: 'date' },
      { key: 'payment_type', label: 'Type', type: 'select', options: ['cash', 'bank'] },
    ],
    summaryKeys: [
      { key: 'count', label: 'Payments', icon: 'bi bi-credit-card' },
      { key: 'amount', label: 'Amount', money: true },
      { key: 'wht_amount', label: 'WHT', money: true },
      { key: 'net_received', label: 'Net Received', money: true },
    ],
    columns: [
      { key: 'id', label: 'ID' },
      { key: 'payment_date', label: 'Date' },
      { key: 'payment_type', label: 'Type' },
      { key: 'amount', label: 'Amount', render: (r) => Number(r.amount || 0).toLocaleString() },
      { key: 'wht_amount', label: 'WHT', render: (r) => Number(r.wht_amount || 0).toLocaleString() },
      { key: 'net_amount', label: 'Net', render: (r) => Number(r.net_amount || 0).toLocaleString() },
    ],
  },
  {
    key: 'vouchers',
    label: 'Vouchers Report',
    fileName: 'vouchers_report',
    endpoint: (p) => api.reports.vouchers(p),
    filters: [
      { key: 'from', label: 'From', type: 'date' },
      { key: 'to', label: 'To', type: 'date' },
      { key: 'voucher_type', label: 'Type', type: 'select', options: ['general_voucher', 'bank_payment', 'bank_receipt', 'cash_payment', 'cash_receipt'] },
      { key: 'status', label: 'Status', type: 'select', options: ['draft', 'posted', 'void'] },
    ],
    summaryKeys: [
      { key: 'count', label: 'Vouchers', icon: 'bi bi-receipt' },
      { key: 'total_debit', label: 'Total Debit', money: true },
      { key: 'total_credit', label: 'Total Credit', money: true },
    ],
    columns: [
      { key: 'voucher_no', label: 'Voucher No' },
      { key: 'date', label: 'Date' },
      { key: 'voucher_type', label: 'Type' },
      { key: 'status', label: 'Status' },
      { key: 'narration', label: 'Narration', render: (r) => (r.narration ? String(r.narration).toUpperCase() : '-') },
    ],
  },
  {
    key: 'parties',
    label: 'Parties Report',
    fileName: 'parties_report',
    endpoint: (p) => api.reports.parties(p),
    filters: [
      { key: 'type', label: 'Type', type: 'select', options: ['customer', 'supplier', 'both'] },
      { key: 'search', label: 'Search', type: 'text' },
    ],
    summaryKeys: [],
    columns: [
      { key: 'name', label: 'Party' },
      { key: 'type', label: 'Type' },
      { key: 'opening_balance', label: 'Opening', render: (r) => Number(r.opening_balance || 0).toLocaleString() },
      { key: 'invoiced', label: 'Invoiced', render: (r) => Number(r.invoiced || 0).toLocaleString() },
      { key: 'received', label: 'Received', render: (r) => Number(r.received || 0).toLocaleString() },
      { key: 'closing_balance', label: 'Closing', render: (r) => Number(r.closing_balance || 0).toLocaleString() },
    ],
  },
  {
    key: 'party-statement',
    label: 'Party Statement',
    fileName: 'party_statement',
    needsParty: true,
    endpoint: (p) => api.reports.partyStatement(p.party_id, p),
    filters: [
      { key: 'party_id', label: 'Party', type: 'party' },
      { key: 'from', label: 'From', type: 'date' },
      { key: 'to', label: 'To', type: 'date' },
    ],
    summaryKeys: [
      { key: 'opening_balance', label: 'Opening', money: true },
      { key: 'closing_balance', label: 'Closing', money: true },
      { key: 'total_debit', label: 'Total Debit', money: true },
      { key: 'total_credit', label: 'Total Credit', money: true },
    ],
    columns: [
      { key: 'date', label: 'Date' },
      { key: 'reference', label: 'Reference' },
      { key: 'type', label: 'Type' },
      { key: 'debit', label: 'Debit', render: (r) => Number(r.debit || 0).toLocaleString() },
      { key: 'credit', label: 'Credit', render: (r) => Number(r.credit || 0).toLocaleString() },
      { key: 'balance', label: 'Balance', render: (r) => Number(r.balance || 0).toLocaleString() },
    ],
  },
  {
    key: 'employees',
    label: 'Employees Report',
    fileName: 'employees_report',
    endpoint: (p) => api.reports.employees(p),
    filters: [
      { key: 'employee_type', label: 'Type', type: 'select', options: ['helper', 'operator', 'staff'] },
      { key: 'search', label: 'Search', type: 'text' },
    ],
    summaryKeys: [
      { key: 'monthly_cost', label: 'Monthly Cost', money: true },
    ],
    columns: [
      { key: 'name', label: 'Employee' },
      { key: 'employee_type', label: 'Type' },
      { key: 'basic_salary', label: 'Basic Salary', render: (r) => Number(r.basic_salary || 0).toLocaleString() },
      { key: 'monthly_cost', label: 'Monthly Cost', render: (r) => Number(r.monthly_cost || 0).toLocaleString() },
      { key: 'avg_net', label: 'Avg Net', render: (r) => Number(r.avg_net || 0).toLocaleString() },
    ],
  },
  {
    key: 'payroll',
    label: 'Payroll Report',
    fileName: 'payroll_report',
    endpoint: (p) => api.reports.payroll(p),
    filters: [
      { key: 'month', label: 'Month', type: 'month' },
      { key: 'status', label: 'Status', type: 'select', options: ['draft', 'approved', 'processed'] },
    ],
    summaryKeys: [
      { key: 'count', label: 'Employees', icon: 'bi bi-people-fill' },
      { key: 'gross_earnings', label: 'Gross', money: true },
      { key: 'special_thread_amount', label: 'Special Thread', money: true },
      { key: 'total_deductions', label: 'Deductions', money: true },
      { key: 'net_salary', label: 'Net Salary', money: true },
    ],
    columns: [
      { key: 'employee_name', label: 'Employee' },
      { key: 'month', label: 'Month' },
      { key: 'gross_earnings', label: 'Gross', render: (r) => Number(r.gross_earnings || 0).toLocaleString() },
      { key: 'total_deductions', label: 'Deductions', render: (r) => Number(r.total_deductions || 0).toLocaleString() },
      { key: 'net_salary', label: 'Net', render: (r) => Number(r.net_salary || 0).toLocaleString() },
    ],
  },
  {
    key: 'attendance',
    label: 'Attendance Report',
    fileName: 'attendance_report',
    endpoint: (p) => api.reports.attendance(p),
    filters: [
      { key: 'from', label: 'From', type: 'date' },
      { key: 'to', label: 'To', type: 'date' },
    ],
    summaryKeys: [
      { key: 'present', label: 'Present', icon: 'bi bi-check-circle-fill' },
      { key: 'late', label: 'Late', icon: 'bi bi-clock-history' },
      { key: 'absent', label: 'Absent', icon: 'bi bi-x-circle-fill' },
      { key: 'leave', label: 'Leave', icon: 'bi bi-umbrella-beach' },
    ],
    columns: [
      { key: 'employee_name', label: 'Employee' },
      { key: 'present', label: 'Present' },
      { key: 'late', label: 'Late' },
      { key: 'absent', label: 'Absent' },
      { key: 'leave', label: 'Leave' },
      { key: 'late_days', label: 'Late Days' },
    ],
  },
  {
    key: 'machines',
    label: 'Machines Report',
    fileName: 'machines_report',
    endpoint: (p) => api.reports.machines(p),
    filters: [
      { key: 'from', label: 'From', type: 'date' },
      { key: 'to', label: 'To', type: 'date' },
    ],
    summaryKeys: [
      { key: 'total_stitches', label: 'Total Stitches', icon: 'bi bi-gear-wide-connected' },
      { key: 'total_special_stitches', label: 'Special', icon: 'bi bi-stars' },
      { key: 'estimated_earning', label: 'Est. Earning', money: true },
    ],
    columns: [
      { key: 'machine_code', label: 'Code' },
      { key: 'name', label: 'Machine' },
      { key: 'head_type', label: 'Heads' },
      { key: 'total_stitches', label: 'Stitches', render: (r) => Number(r.total_stitches || 0).toLocaleString() },
      { key: 'days_worked', label: 'Days' },
      { key: 'avg_stitches_per_day', label: 'Avg/Day', render: (r) => Number(r.avg_stitches_per_day || 0).toLocaleString() },
      { key: 'estimated_earning', label: 'Earning', render: (r) => Number(r.estimated_earning || 0).toLocaleString() },
      { key: 'assigned_employee', label: 'Employee' },
    ],
  },
  {
    key: 'stitches',
    label: 'Stitches Report',
    fileName: 'stitches_report',
    endpoint: (p) => api.reports.stitches(p),
    filters: [
      { key: 'from', label: 'From', type: 'date' },
      { key: 'to', label: 'To', type: 'date' },
    ],
    summaryKeys: [
      { key: 'count', label: 'Entries', icon: 'bi bi-pencil-square' },
      { key: 'total_stitches', label: 'Total Stitches', icon: 'bi bi-gear-wide-connected' },
      { key: 'special_stitches', label: 'Special', icon: 'bi bi-stars' },
    ],
    columns: [
      { key: 'date', label: 'Date' },
      { key: 'machine', label: 'Machine' },
      { key: 'employee', label: 'Employee' },
      { key: 'stitch_count', label: 'Stitches', render: (r) => Number(r.stitch_count || 0).toLocaleString() },
      { key: 'special_thread', label: 'Special' },
    ],
  },
  {
    key: 'gatepasses',
    label: 'Gatepass Report',
    fileName: 'gatepasses_report',
    endpoint: (p) => api.reports.gatepasses(p),
    filters: [
      { key: 'type', label: 'Type', type: 'select', options: ['IN', 'OUT'] },
      { key: 'search', label: 'Search', type: 'text' },
      { key: 'from', label: 'From', type: 'date' },
      { key: 'to', label: 'To', type: 'date' },
    ],
    summaryKeys: [
      { key: 'count', label: 'Entries', icon: 'bi bi-door-open' },
      { key: 'items_in', label: 'Items In', icon: 'bi bi-box-arrow-in-down' },
      { key: 'items_out', label: 'Items Out', icon: 'bi bi-box-arrow-up' },
    ],
    columns: [
      { key: 'gatepass_no', label: 'No' },
      { key: 'date', label: 'Date' },
      { key: 'type', label: 'Type' },
      { key: 'company_name', label: 'Company' },
      { key: 'person_name', label: 'Person' },
      { key: 'vehicle_no', label: 'Vehicle' },
    ],
  },
  {
    key: 'inventory',
    label: 'Inventory Report',
    fileName: 'inventory_report',
    endpoint: (p) => api.reports.inventory(p),
    filters: [
      { key: 'article_no', label: 'Article No', type: 'text' },
      { key: 'from', label: 'From', type: 'date' },
      { key: 'to', label: 'To', type: 'date' },
    ],
    summaryKeys: [
      { key: 'total_in', label: 'Stock In', icon: 'bi bi-box-arrow-in-down' },
      { key: 'total_out', label: 'Stock Out', icon: 'bi bi-box-arrow-up' },
      { key: 'negative_balance_articles', label: 'Negative', icon: 'bi bi-exclamation-triangle-fill' },
    ],
    columns: [
      { key: 'article_no', label: 'Article No' },
      { key: 'name', label: 'Name' },
      { key: 'unit', label: 'Unit' },
      { key: 'total_in', label: 'In', render: (r) => Number(r.total_in ?? 0).toLocaleString() },
      { key: 'total_out', label: 'Out', render: (r) => Number(r.total_out ?? 0).toLocaleString() },
      { key: 'balance', label: 'Balance', render: (r) => {
        const bal = Number(r.balance ?? 0);
        return <b style={{ color: r.is_negative || bal < 0 ? '#ff5630' : 'inherit' }}>{bal.toLocaleString()}</b>;
      } },
      { key: 'is_negative', label: 'Status', render: (r) => r.is_negative ? <span className="badge badge-red">Negative</span> : <span className="badge badge-green">OK</span> },
    ],
  },
  {
    key: 'activity-logs',
    label: 'Activity Logs Report',
    fileName: 'activity_logs_report',
    endpoint: (p) => api.reports.activityLogs(p),
    filters: [
      { key: 'activity', label: 'Activity', type: 'select', options: ['CREATED', 'UPDATED', 'DELETED', 'LOGIN', 'LOGOUT', 'POSTED', 'VOIDED', 'APPROVED', 'PAYROLL_GENERATED', 'PAYROLL_PROCESSED'] },
      { key: 'from', label: 'From', type: 'date' },
      { key: 'to', label: 'To', type: 'date' },
    ],
    summaryKeys: [
      { key: 'total', label: 'Total Logs', icon: 'bi bi-clipboard-data' },
    ],
    columns: [
      { key: 'created_at', label: 'Timestamp' },
      { key: 'user', label: 'User', render: (r) => (r.user ? r.user.name : '-') },
      { key: 'activity', label: 'Activity' },
      { key: 'description', label: 'Description' },
    ],
  },
  {
    key: 'sales-summary',
    label: 'Sales Summary',
    fileName: 'sales_summary_report',
    endpoint: (p) => api.reports.salesSummary(p),
    filters: [
      { key: 'from', label: 'From', type: 'date' },
      { key: 'to', label: 'To', type: 'date' },
      { key: 'group_by', label: 'Group By', type: 'select', options: ['day', 'week', 'month'] },
    ],
    summaryKeys: [
      { key: 'count', label: 'Invoices', icon: 'bi bi-file-earmark-text' },
      { key: 'subtotal', label: 'Subtotal', money: true },
      { key: 'total', label: 'Total', money: true },
      { key: 'received', label: 'Received', money: true },
      { key: 'pending', label: 'Pending', money: true },
    ],
    columns: [
      { key: 'period', label: 'Period' },
      { key: 'count', label: 'Invoices' },
      { key: 'subtotal', label: 'Subtotal', render: (r) => Number(r.subtotal || 0).toLocaleString() },
      { key: 'total', label: 'Total', render: (r) => Number(r.total || 0).toLocaleString() },
      { key: 'received', label: 'Received', render: (r) => Number(r.received || 0).toLocaleString() },
    ],
  },
  {
    key: 'invoice-summary-details',
    label: 'FBR Invoice Summary',
    fileName: 'invoice_summary_details',
    endpoint: (p) => api.reports.invoiceSummaryDetails(p),
    customExcel: true,
    filters: [
      { key: 'from', label: 'From', type: 'date' },
      { key: 'to', label: 'To', type: 'date' },
      { key: 'party_id', label: 'Party', type: 'party' },
      { key: 'search', label: 'Search', type: 'text' },
    ],
    summaryKeys: [
      { key: 'count', label: 'Items', icon: 'bi bi-file-earmark-text' },
      { key: 'total_quantity', label: 'Total Quantity', icon: 'bi bi-boxes' },
      { key: 'total_value', label: 'Value Excl. ST', money: true },
      { key: 'total_tax', label: 'Sales Tax', money: true },
      { key: 'total', label: 'Total Value', money: true },
    ],
    columns: [
      { key: 'date', label: 'Invoice Date' },
      { key: 'invoice_type', label: 'Invoice Type' },
      { key: 'buyer_ntn_cnic', label: 'Buyer NTN CNIC' },
      { key: 'invoice_no', label: 'Invoice Ref No' },
      { key: 'hs_code', label: 'HS Code' },
      { key: 'description', label: 'Product Description' },
      { key: 'uom', label: 'UOM' },
      { key: 'unit_cost', label: 'Unit Cost', render: (r) => Number(r.unit_cost || 0).toLocaleString() },
      { key: 'quantity', label: 'Quantity', render: (r) => Number(r.quantity || 0).toLocaleString() },
      { key: 'rate', label: 'Rate' },
      { key: 'value_excl_st', label: 'Value Excl. ST', render: (r) => Number(r.value_excl_st || 0).toLocaleString() },
      { key: 'sales_tax', label: 'Sales Tax', render: (r) => Number(r.sales_tax || 0).toLocaleString() },
      { key: 'further_tax', label: 'Further Tax' },
      { key: 'total_value', label: 'Total Values', render: (r) => Number(r.total_value || 0).toLocaleString() },
      { key: 'sro_item_serial_no', label: 'SRO Item Serial No' },
      { key: 'sro_schedule_no', label: 'SRO Schedule No' },
      { key: 'sale_type', label: 'Sale Type' },
    ],
  },
  {
    key: 'invoice-summary',
    label: 'Invoice Summary',
    fileName: 'invoice_summary',
    endpoint: (p) => api.reports.invoiceSummary(p),
    customExcel: (rows, fileName) => exportInvSummaryExcel(rows, fileName),
    filters: [
      { key: 'from', label: 'From', type: 'date' },
      { key: 'to', label: 'To', type: 'date' },
      { key: 'party_id', label: 'Party', type: 'party' },
      { key: 'invoice_type', label: 'Type', type: 'select', options: ['sale', 'credit', 'tax_free', 'commission', 'purchase'] },
      { key: 'search', label: 'Search', type: 'text' },
    ],
    summaryKeys: [
      { key: 'count', label: 'Invoices', icon: 'bi bi-file-earmark-text' },
      { key: 'total_quantity', label: 'Quantity', icon: 'bi bi-boxes' },
      { key: 'total_excl', label: 'Excl. Amount', money: true },
      { key: 'total_incl', label: 'Incl. Amount', money: true },
    ],
    columns: [
      { key: 'invoice_no', label: 'Inv #' },
      { key: 'party_name', label: 'Party Name' },
      { key: 'invoice_type', label: 'Inv Type' },
      { key: 'date', label: 'Date', render: (r) => formatDate(r.date) },
      { key: 'sales_tax_desc', label: 'Sales Tax' },
      { key: 'tax_rate', label: 'Sales Tax %' },
      { key: 'excl_amount', label: 'Excluding Amount', render: (r) => Number(r.excl_amount || 0).toLocaleString() },
      { key: 'quantity', label: 'Quantity', render: (r) => Number(r.quantity || 0).toLocaleString() },
      { key: 'incl_amount', label: 'Including Amount', render: (r) => Number(r.incl_amount || 0).toLocaleString() },
      { key: 'ntn_no', label: 'NTN #' },
    ],
  },
];

export const getReportDef = (key) => REPORT_DEFS.find((r) => r.key === key);
